import React, { lazy, memo, Suspense, useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Routes, Route, useLocation } from 'react-router-dom'

import Authenticator from './containers/Authenticator'
import { LanguageContext } from './context/LanguageContext'
import Layout from './containers/Layout'
import { Loader } from './components/common'
import { PreventNavigationProvider } from './providers'

/* All style files should import in the index.scss file */
import './scss/index.scss'
import RoutesConfig from './RoutesConfig'

const Logout = lazy(() => import('./containers/Logout'))

const App = () => {
    const location = useLocation()
    //Path
    const [pathname, setPathName] = useState(location.pathname)
    useEffect(() => {
        setPathName(location.pathname)
    }, [location.pathname])

    //Loader
    const fetchingLanguage = useSelector(state => state.common.fetching_language)
    const userPermissions = useSelector(state => state.auth.user_permissions)
    const settingUserInfo = useSelector(state => state.auth.setting_user_info)
    const configLoading = useSelector(state => state.common.config_loading)
    const { rtl } = useContext(LanguageContext)

    if (fetchingLanguage || (settingUserInfo && !userPermissions.length) || configLoading) {
        return <Loader loading={true} />
    }

    document.dir = rtl ? 'rtl' : 'ltr'

    //Render
    return (
        <div className={'Adp-app'}>
            <Suspense fallback={<Loader loading={true} />}>
                <PreventNavigationProvider>
                    <Routes>
                        <Route path={'/logout'} element={<Logout />} />
                        <Route
                            path="/"
                            element={
                                <Authenticator>
                                    <Layout key={pathname} pathname={pathname} />
                                </Authenticator>
                            }
                        >
                            {RoutesConfig()}
                            <Route path="*" element={<Navigate to="/dashboard" replace />} />
                        </Route>
                    </Routes>
                </PreventNavigationProvider>
            </Suspense>
        </div>
    )
}

export default memo(App)
